import React from 'react'
import styles from './BusinessDetailReport.module.scss'

export default class ReportErrorBoundary extends React.Component {
    state = { failed: false }

    static getDerivedStateFromError() {
        return { failed: true }
    }

    componentDidCatch(error) {
        console.error('Report could not be displayed', error)
    }

    componentDidUpdate(prev) {
        if (this.state.failed && prev.data !== this.props.data) this.setState({ failed: false })
    }

    render() {
        if (this.state.failed) {
            return (
                <div className={styles.body}>
                    <div className={styles.calmLine} role='alert'>
                        This report could not be displayed. The Lexis PDF still has the full report; if it keeps happening, contact support.
                    </div>
                </div>
            )
        }
        return this.props.children
    }
}

export const withReportErrorBoundary = (Component, dataProp) => function SafeReport(props) {
    return (
        <ReportErrorBoundary data={props[dataProp]}>
            <Component {...props} />
        </ReportErrorBoundary>
    )
}
